import { Box, NakedButton } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { hideVisually } from 'polished';

export const HiddenLabel = styled.span`
  ${hideVisually()}
`;

export const DropdownWrapper = styled(Box)`
  background: ${themeGet('colors.white')};
  box-shadow: ${themeGet('shadows.dropdown')};
  border-radius: ${themeGet('radii.default')};
  padding: ${themeGet('space.2')} 0;
`;

export const DropdownItem = styled(NakedButton)`
  padding: ${themeGet('space.2')} ${themeGet('space.6')};
  color: ${themeGet('colors.greys.charcoal')};
  display: block;
  width: 100%;
  text-align: left;
  text-decoration: none;

  ${(props) =>
    props.highlighted &&
    css`
      background-color: ${themeGet('colors.greys.porcelain')(props)};
    `}
`;
